import React, { useRef, useState, useEffect } from 'react';
import ReactPlayer from 'react-player';
import { useSelector, useDispatch } from 'react-redux';

import { useWindowSize } from '../../../models/Hooks';
import { calculateSize, getImageFilepath } from '../../../models/Utils';
import { ReactComponent as CloseBtn } from '../../../assets/images/graphics/btn-close.svg';
import './VideoSlide.scss';
import { setInFullScreenVideo } from '../../../store/reducers/mainReducer';
import { reportEvent } from '../../../store/reducers/gaReducer';
import Spinner from '../../Common/Spinner/Spinner';
import { ADAWidgitRoles } from '../../../models/ADA';

const VideoSlide = ({ data, active, playOnActive, closeButton, doNotHideLoading, forceShowControls, showPlayButton=true, canPlay=true, onPlaying }) => {
  const dispatch = useDispatch();
  const player = useRef(null);
  const [playing, setPlaying] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const updateIntervalMs = 50;
  const [muted, setMuted] = useState(true);
  const [fullscreen, goToFullscreen] = useState(false);
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);
  const videoTimeout = useSelector(state => state.data.videoFadeTimeout);
  const menuOpened = useSelector(state => state.data.menuOpened);

  const size = useWindowSize();
  const dimensions = calculateSize(1920, 1080, size.width, size.height);

  useEffect(() => {
    clearTimeout(fadeTimeout);

    if (!active) {
      handleOnExit();
  
      setTimeout(() => {
        setPlaying(false);
      }, 1000);
      if (player.current && loaded) {
        player.current.seekTo(0, 'fraction');
      }
      setLoaded(false);
    } else {
      setPlaying(true);
      delayedFade();
      //if (playOnActive) {
        //goToFullscreen(true);
      //}
    }
  }, [active]);

  /* Video Events */
  function handleVideoStart() {
    if(active){
      setLoaded(true);
    }
  }

  var fadeTimeout;
  function delayedFade() {
    fadeTimeout = setTimeout(handleVideoStart, videoTimeout);
  }

  const handleOnExit = () => {
    goToFullscreen(false);
    dispatch(setInFullScreenVideo(false));
    setMuted(true);
    if(onPlaying){
      onPlaying(false);
    }
  };

  const onPlayVideo = () => {
    goToFullscreen(true);
    dispatch(setInFullScreenVideo(true));
    dispatch(reportEvent({ category:"VIDEO_PLAYED_PBP_SLIDE", action: data.Text.Header + " - " + data.Video.URL}));
    setMuted(false);
    if(onPlaying){
      onPlaying(true);
    }
  };

  const handleOverlayClick = () => {
    setPlaying(!playing);
  }

  const videoURL = !fullscreen && data.Video.BackgroundMedia ? mediaPath + data.Video.BackgroundMedia : !fullscreen && data.VideoPreview ? data.VideoPreview.URL : data.Video.URL;
  console.log("video log", data, videoURL)
  var video = (
    <div role="img" className="video-inner" alt={data.Video.AltText} >
      <ReactPlayer
        ref={player}
        className="video"
        url={videoURL}
        width={fullscreen ? "100%" : dimensions.width + 'px'}
        height={fullscreen ? "100%" : dimensions.height + 'px'}
        playing={playing}
        playsinline={!fullscreen}
        controls={fullscreen || forceShowControls}
        loop={muted}
        onStart={handleVideoStart}
        muted={muted}
        config={{
          youtube: {
            playerVars: {
              showinfo: 1,
              modestbranding: 1,
              rel: 0,
            },
          },
        }}
        progressInterval={updateIntervalMs}
      />
      <div className="video-touch-overlay" onClick={handleOverlayClick} onKeyPress={handleOverlayClick} alt={"Play Video"} role={ADAWidgitRoles.Button} tabIndex={active && !menuOpened ? 0 : -1}></div>
    </div>
  );



  var imagePlaceholder = data.Video.BackgroundMedia ?
    (<img src={mediaPath + getImageFilepath(data.Video.BackgroundMedia, window.innerWidth * 0.4 > 200 ? 200 : window.innerWidth * 0.4)}
      className="background-image" />
    ) : null;

  var classname = 'video-placeholder ' + (loaded || doNotHideLoading ? 'loaded' : '');
  var fullscreenClass = 'video-fullscreen '  + (loaded || doNotHideLoading ? 'loaded' : '');


  return (
    <div className="video-slide">
      {fullscreen ? (
        <div className={fullscreenClass}>
          {active ? videoURL || data.Video.BackgroundMedia && data.Video.BackgroundMedia.split(".").pop() === "mp4" ? video : imagePlaceholder : null}
          {closeButton ? <CloseBtn className="exit-button" alt="Close Video Button" onKeyPress={handleOnExit} onClick={handleOnExit} tabIndex={active && !menuOpened ? 0 : -1} /> : null}
        </div>
        
      ) : (
        <>
          {data.Thumbnail && data.Thumbnail.Image ? (
            <div
              className="thumbnail"
              style={{ backgroundImage: `url("${mediaPath + data.Thumbnail.Image}")` }}
              alt={data.Thumbnail.AltText}
            >
              <div
                className="overlay"
                style={{
                  backgroundColor: data.Thumbnail.Overlay,
                  opacity: data.Thumbnail.Opacity,
                  pointerEvents: (canPlay && !showPlayButton) ? 'all' : 'unset'
                }}
                onKeyPress={(canPlay && !showPlayButton) ? onPlayVideo : null} onClick={(canPlay && !showPlayButton) ? onPlayVideo : null}
                tabIndex={active && !menuOpened ? 0 : -1}
                role="button"
                aria-label="Play Video"
              />
            </div>
          ) : (
            <>
              <div className="videoBackground"/>
               <Spinner/>
              <div className={classname}>{active ? videoURL || data.Video.BackgroundMedia && data.Video.BackgroundMedia.split(".").pop() === "mp4" ? video : imagePlaceholder : null}</div>
            
              <div
                className="overlay"
                style={{
                  backgroundColor: data.Video.Overlay,
                  opacity: data.Video.Opacity,
                }}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default VideoSlide;
